import React from 'react';

export function FilterPanel({ headerGroups, activeFilters, tableName }) {
    React.useEffect(() => {
        // console.log(activeFilters);
        // console.log(headerGroups);
    }, [activeFilters]);

    return (
        <div key="filter" className='filters'>
            {
                /* eslint-disable array-callback-return */
                headerGroups.map(headerGroup => (
                    headerGroup.headers.map(column => {
                        if (shouldShow(column)) {
                            return <div key={column.id} className='filter'> {column.render('Filter')}</div>
                        } else {
                            return ''
                        }
                    }
                    )))
                /* eslint-enable array-callback-return */
            }
        </div>
    )

    function shouldShow(column) {
        if (column.canFilter && activeFilters && activeFilters.length > 0) {
            return incl(activeFilters, column);
        } else {
            return false;
        }
    }

    function incl(obj, column) {
        let incl = false;
        if (obj) {
            /* eslint-disable array-callback-return */
            obj.map(o => {
                if (o.value === column.id) {
                    incl = true;
                }
            })
            /* eslint-enable array-callback-return */
        } else {
            return false;
        }
        return incl;
    }
}